import { InjectionToken } from '@angular/core';
/**
 * @hidden
 */
export var CELL_CONTEXT = new InjectionToken('grid-cell-context');
/**
 * @hidden
 */
export var EMPTY_CELL_CONTEXT = {};



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/rendering/common/cell-context.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/rendering/common/cell-context.js
// module chunks = vendor